import Vue from 'vue'
import Vuex from 'vuex'
import events from './modules/events'
import staff from './modules/staffDirectory'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    events,
    staff
  }
})
